import { Box } from "@mui/material";
import welcomeAdmin from "../../../assets/images/welcome-admin.svg";
import styles from "../Admin.module.scss";
import { useTranslation } from "react-i18next";

const WelcomeAdmin: React.FC = () => {
const { t } = useTranslation();

  return (
    <Box className={styles.welcomeAdmin}>
      <h2>{t("welcomeToAdmin")}</h2>
      <img src={welcomeAdmin} alt="welcome" />
    </Box>
  );
};

export default WelcomeAdmin;
